// Minimal i18n helper. Extend as needed.
export const translations = {
  en: {
    nav: {
      home: "Home",
      features: "Features",
      pricing: "Pricing Plans",
      contact: "Contact Us",
      get_in_touch: "GET IN TOUCH",
      login_label: "Login"
    },
    hero: {
      title: "ALL IN ONE PLACE",
    },
    features: {
      features: "Features",
      naahell: "Naahel Cyber",
    },
    steps: {
      getting_started: "Getting Started",
      simple: "Simple Steps to",
      launch: "With Naahel Cyber",
      startednow: "Get Started Now",
      step:"Step"
    },
    reviews: {
      reviews: "Reviews",
      change_moments: "Here, We Capture Moments of Transformation",
    },
    faq: {
      your_quick_guide: "YOUR QUICK GUIDE",
      exp_nc: "To explore Naahel Cyber",
      get_questions: "Got Questions?",
      get_answers: "We've Got Answers",
      title: "FREQUENTLY ASKED QUESTIONS (FAQ) – NAAHEL CYBER",
      description:
        "We provide everything you need — from phishing simulations to tools that boost your employees’ cybersecurity awareness Partner with Naahel Cyber to enhance your organization’s protection, readiness, and resilience..",
    },
    pricing: {
      subtitle: "Pricing Plans",
      request_offer: "Request Quotation",
      request_a_quote: "REQUEST A QUOTE"
    },
    trusted: {
      trustedBy: "Trusted By",
    },
    footer: {
      "about-naahelcyber": "About Naahel Cyber",
      "pricing-planes": "Pricing Plans",
      news: "News",
      investors: "Investors",
      faq: "FAQ",
      "site-map": "Site Map",
      certified: "Certified by",
      developed: "Naahel Cyber developed by",
      copyright: "Copy Rights Reserved © Naahel Cyber 2025",
      terms_conditions: "Terms and Conditions",
      privacy: "Privacy & Cookies",
      accessibilies: "Accessibility",
    },

    services: {
      buttonTitle: "GET IN TOUCH TO LEARN MORE",
    },

    cta: {
      request_demo: "REQUEST A DEMO",
      request_quote: "REQUEST QUOTATION",
    },
    sections: {
      features: "FEATURES",
      pricing_title: "Pricing Plans",
      reviews: "REVIEWS",
    },
    contact: {
      title: "Contact Us",
      "sub-title": "Let's Communicate",
      "sub-enp-title": "We Value Your Thoughts",
      name: "Name..",
      organization: "Organization Name..",
      email: "Email..",
      phone: "Phone..",
      reason: "The Reason",
      request_offer: "Request a quote",
      connectType: "How do you know us?",
      subject: "The Subject..",
      message: "The Message..",
      send: "Send",
      message_sent: "Message Sent!",
      messsage_text: "Your inquiry has been submitted successfully",
      failed_message: "Submission Failed",
      failed_text: "There was an error sending your request. Please try again.",
      sending_text: "Sending...",
      sending_message: "Please wait while we submit your request.",
      ticket_id: "Ticket ID",
      content: "Content",
      contact: "Contact",
      ticket_submitted: "Your Ticket is Submitted!",
      ticket_confirmation_text: "Thank you! Your ticket has been successfully created. Here are the details:",
      validation_error: "Please fill all the details",

    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      features: "الميزات",
      pricing: "باقات الأسعار",
      contact: "تواصل معنا",
      get_in_touch: "تواصل معنا",
      login_label: "تسجيل الدخول"
    },
    hero: {
      title: "كل ما تحتاجه في مكان واحد",
    },
    features: {
      features: "الميزات",
      naahell: "ناهل سايبر",
    },
    steps: {
      getting_started: "ابدأ الآن",
      simple: "خطوات بسيطة",
      launch: "للإنطلاق مع ناهل",
      startednow: "ابدأ الأن",
      step: "الخطوة"
    },
    services: {
      buttonTitle: "تواصل معنا واكتشف أكثر",
    },
    reviews: {
      reviews: "آراء",
      change_moments: "هنا نُخلّد لحظات التحوّل"
    },
    faq: {
      your_quick_guide: "دليلك السريع",
      exp_nc: "لاستكشاف ناهل سايبر",
      get_questions: "هل لديك أسئلة؟",
      get_answers: "نملك كل الإجابات",
      title: "الأسئلة المتكررة (FAQ) – ناهل سايبر",
      description:
  "نقدم كل ما تحتاجه — من محاكاة الهجمات الاحتيالية إلى الأدوات التي تعزز وعي موظفيك بأمن المعلومات. شارك مع ناهل سايبر لتعزيز حماية منظمتك واستعدادها ومرونتها.",
    },
    pricing: {
      subtitle: "خطط التسعير",
      request_offer: "طلب عرض أسعار",
      request_a_quote: "اطلب عرض سعر",
    },
    trusted: {
      trustedBy: "شركاؤنا",
    },
    footer: {
      "about-naahelcyber": "عن ناهل سايبر",
      "pricing-planes": "خطط الأسعار",
      news: "الأخبار",
      investors: "المستثمرون",
      faq: "الأسئلة الشائعة",
      "site-map": "خريطة الموقع",
      certified: "معتمد من قبل",
      developed: "ناهل سايبر مطور بواسطة",
      copyright: "جميع الحقوق محفوظة © ناهل سايبر 2025",
      terms_conditions: "الشروط والأحكام",
      privacy: "سياسة الخصوصية وملفات تعر يف الارتباط",
      accessibilies: "إمكانية الوصول",
    },

    cta: {
      request_demo: "اطلب عرضا",
      request_quote: "طلب عرض سعر",
    },
    sections: {
      features: "الميزات",
      pricing_title: "باقات الأسعار",
      reviews: "التقييمات",
    },
    contact: {
      title: "تواصل معنا",
      "sub-title": "دعونا نتواصل",
      "sub-enp-title": "نُقدّر آراءكم",
      name: "الإسم..",
      organization: "اسم المؤسسة..",
      email: "الايميل..",
      phone: "الهاتف..",
      reason: "السبب",
      request_offer: "اطلب عرض سعر",
      connectType: "ما هي وسيلة معرفتك بنا؟",
      subject: "الموضوع..",
      message: "الرسالة..",
      send: "إرسال",
      message_sent: "تم إرسال الرسالة!",
      messsage_text: "تم تقديم استفسارك بنجاح",
      failed_message: "فشل الإرسال",
      failed_text: "حدث خطأ أثناء إرسال طلبك. يرجى المحاولة مرة أخرى.",
      sending_text: "جاري الإرسال...",
      sending_message: "يرجى الانتظار أثناء تقديم طلبك.",
      ticket_id: "رقم التذكرة",
      content: "المحتوى",
      contact: "جهة الاتصال",
      ticket_submitted: "تم إرسال تذكرتك!",
      ticket_confirmation_text: "شكراً! تم إنشاء تذكرتك بنجاح. فيما يلي التفاصيل:",
      validation_error: "يرجى تعبئة جميع التفاصيل"

    },
  },
};

export const t = (lang, path, fallback = "") => {
  try {
    const parts = path.split(".");
    let node = translations[lang] || translations.en;
    for (const p of parts) node = node?.[p];
    return (typeof node === "string" && node) || fallback || path;
  } catch (_) {
    return fallback || path;
  }
};
